/*** IMPORTS FROM imports-loader ***/
var fetchPolyfill = require("web/script/polyfills/fetch");
var classListPolyfill = require("web/script/polyfills/classList");

import baustein from "baustein";
import trackedLinkMixin from "./mixins/tracked-link-mixin";

/**
 * This component is here for convenience i.e when you just want a vanilla tracked link
 */
export default baustein.register("tracked-link", {
    mixins: [trackedLinkMixin]
});

